export const discounts_credits = {
   id: "discounts_credits",
   title: "Discounts & Credits",
   family: "discounts_credits",
   endpoint: "/rundiscounts.sz",
   defaultSort: { key: "discount_amount", dir: "desc" },
   groupBy: ["supplier"],
   groupOptions: [
      { value: "supplier",  label: "Supplier" },
      { value: "location",  label: "Location" },
      { value: "line_type", label: "Type" },
   ],
   categoryField: "line_type",
   categoryLabel: "Type",
   minField: "statement_amount",
   minLabel: "Min amount $",
   params: [
      { key: "period", type: "month", label: "Period" },
      { key: "locations", type: "multiselect", label: "Locations" },
      { key: "suppliers", type: "multiselect", label: "Suppliers" },
      { key: "minVariance", type: "number", label: "Min $" },
   ],
   summary: [
      { key: "lines",     label: "Lines",       type: "int",   agg: "count" },
      { key: "discounts", label: "$ Discounts", type: "money", agg: "sum", column: "discount_amount" },
      { key: "credits",   label: "$ Credits",   type: "money", agg: "sum", column: "credit_amount" },
   ],
   columns: [
      { key: "supplier",         label: "Supplier",  type: "text",  align: "left" },
      { key: "location",         label: "Location",  type: "text",  align: "left" },
      { key: "invoice_no",       label: "Invoice #", type: "text",  align: "left",  drill: "pair" },
      { key: "statement_date",   label: "Statement date", type: "date",  align: "left" },
      { key: "statement_amount", label: "Statement $", type: "money", align: "right", total: "sum" },
      { key: "discount_amount",  label: "Discount $", type: "money", align: "right", total: "sum" },
      { key: "credit_amount",    label: "Credit $",  type: "money", align: "right", total: "sum", accent: true },
      { key: "line_type",        label: "Type",      type: "label", align: "left" },
      { key: "terms",            label: "Terms",     type: "text",  align: "left" },
      { key: "due_date",         label: "Due date",  type: "date",  align: "left" },
   ],
};
